import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=2431bfb1&scoped=true&"
import script from "./CustomSearch.vue?vue&type=script&lang=js&"
export * from "./CustomSearch.vue?vue&type=script&lang=js&"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=2431bfb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431bfb1",
  null
  
)

export default component.exports